import { Component, OnChanges, OnInit, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-direct-drive-primary-valve-package',
    templateUrl: './direct-drive-primary-valve-package.component.html',
    styleUrls: ['./direct-drive-primary-valve-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class DirectDrivePrimaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  primaryValveSizeSelection!: GuruEntity;
  primaryStrainerSelection!: GuruEntity;
  primaryControlValveSelection!: GuruEntity;
  primaryFlowControlSelection!: GuruEntity;
  primaryIsolationBallValveSelection!: GuruEntity;
  primaryIsolationSelection!: GuruEntity;
  primaryServiceFittingSelection!: GuruEntity;
  primaryNormallyOpenSelection!: GuruEntity;
  primaryBalanceOnBypassSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PRIMARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.primaryValveSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryValveSize');
    this.primaryStrainerSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryStrainer');
    this.primaryControlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryControlValve');
    this.primaryFlowControlSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryFlowCntl');
    this.primaryIsolationBallValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolationBallValve');
    this.primaryIsolationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolation');
    this.primaryServiceFittingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryServcFitting');
    this.primaryNormallyOpenSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USNOvalve1');
    this.primaryBalanceOnBypassSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPriBalanceOnBypass');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
